/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-15 15:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, TextContainer, TextStyle, FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Field, reduxForm } from 'redux-form';

import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import * as setupActions from 'actions/setup-actions';
import { isRequired, isEmail } from 'src/helpers/form-validation-helper';
import { prettyText, getShop } from 'src/helpers';

const isRequiredValue = isRequired();
const isEmailValue = isEmail();

type Props = {
  active: boolean,
  removing: boolean,
  handleCancel: () => void,
  handleSubmitEmail: () => void
};

type ComposedProps = Props & WithI18nProps;

class ContactUsModalForm extends Component<ComposedProps> {
  render() {
    const { active, pristine, submitting, handleSubmit, i18n, invalid, loading } = this.props;

    return (
      <Modal
        open={active}
        onClose={this.handleCancel}
        title={i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.contact_modal_title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.sendRequest'),
          disabled: pristine || submitting || invalid,
          loading,
          onAction: handleSubmit(this.handleSubmitEmail.bind(this))
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: this.handleCancel
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <form onSubmit={this.handleDefaultSubmit}>
              <FormLayout>
                <TextStyle>{i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.contact_modal_content_onboarding')}</TextStyle>
                <Field
                  name="email"
                  label={i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.contact_modal_yourmail')}
                  placeholder={i18n.translate('AdminHTML.Common.Placeholder.email')}
                  component={RenderTextField}
                  validate={[isRequiredValue, isEmailValue]}
                />
                <Field
                  name="message"
                  label={i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.contact_modal_message')}
                  placeholder={i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.contact_modal_message_placeholder')}
                  component={RenderTextField}
                  validate={[isRequiredValue]}
                  anotherProps={{ multiline: 5 }}
                />
              </FormLayout>
            </form>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  // Handle default form submit
  handleDefaultSubmit(e) {
    e.preventDefault();
  }

  handleCancel = () => {
    this.props.handleCancel();
  };

  handleSubmitEmail = async data => {
    const { sendSetupFeedback } = this.props;

    const prettyEmail = prettyText(data.email);
    const tenantId = getShop();

    const content = `Theme setup OS 1.0
- Store: ${tenantId}
- Content: ${data.message}
    `;

    const dataForm = {
      email: prettyEmail,
      content,
      featureName: 'Theme Setup'
    };

    await sendSetupFeedback(dataForm);

    this.props.handleSubmitRequest();
  };
}

const mapStateToProps = (state, props) => {
  return {
    loading: state.setup.setupFeedbackLoading,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  sendSetupFeedback: (body: Object) => dispatch(setupActions.sendSetupFeedback(body, ownProps.i18n))
});

const ContactUsModal = reduxForm({
  form: 'ThemeErrorModal', // a unique identifier for this form
  enableReinitialize: true
})(ContactUsModalForm);

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ContactUsModal));
